import type {CSSProperties,ReactNode} from 'react';
import './waiting-screen.css';

export const WAITING_STYLES=['custom','simple','glow','bold','minimal'] as const;
export type WaitingStyle=typeof WAITING_STYLES[number];
export type WaitingBranding={accent?:string;poster_url?:string;waiting_image?:string;waiting_style?:WaitingStyle};
export const DEFAULT_WAITING_MESSAGE='The next show will start soon.';
export function waitingStyle(branding?:WaitingBranding):WaitingStyle{return branding?.waiting_style??(branding?.waiting_image?'custom':'simple');}
export type WaitingScreenValue={
 title:string;
 content_status?:string;
 waiting_message?:string;
 next_live_at?:string|null;
 branding?:WaitingBranding;
};

/** Shared by the room projector and the unsaved studio preview. */
export function WaitingScreen({value,messageEditor}:{value:WaitingScreenValue;messageEditor?:ReactNode}){
 const style=waitingStyle(value.branding),image=style==='custom'?value.branding?.waiting_image:undefined;
 const message=value.waiting_message||DEFAULT_WAITING_MESSAGE;
 const lines=message.split('\n').reduce((count,line)=>count+Math.max(1,Math.ceil(line.length/30)),0);
 const size=Math.min(style==='bold'?6:style==='minimal'?4:5,36/(lines*1.35));
 return <div className="waiting-screen" data-style={style} data-image={!!image} style={{'--waiting-accent':value.branding?.accent||'#00b7ff','--waiting-text-size':`${size}cqw`} as CSSProperties}>
  {image&&<img className="waiting-screen-image" src={image} alt="Waiting screen artwork"/>}
  {!image&&<div className="waiting-screen-copy">
   {messageEditor??<p className="waiting-screen-message">{message}</p>}
   {value.next_live_at&&<p className="waiting-screen-date">Next live: {new Date(value.next_live_at).toLocaleString('en-US',{dateStyle:'medium',timeStyle:'short'})}</p>}
  </div>}
 </div>;
}
